<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-toolbar
        flat
        dark
        class="mb-4"
        >
            <v-toolbar-title>
                <span v-if="isPersonal" class="text-h5">{{ $t('contacts.columns.personalTags') }}</span>
                <span v-else class="text-h5">{{ $t('contacts.columns.tags') }}</span>
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <span v-if="tag">{{ $t('contacts.tagDeleteForm.confirmation') }} <span class="red--text">{{ tag.name }}</span>?</span><br/>
          <i v-if="tag">{{ $tc('contacts.tagDeleteForm.inUseMessage', tag.inUseCount, { inUseCount: tag.inUseCount }) }}</i>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="close()"
          >
            {{ $t('contacts.btn.cancel') }}
          </v-btn>
          <v-btn
            text
            color="red"
            @click="submit()"
          >
            {{ $t('contacts.btn.delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'contacts-tag-deleteForm',
  data () {
    return {
      originalName: null
    }
  },
  computed: {
    ...mapGetters({
      dialog: 'contacts/tagDeleteForm/dialog',
      isPersonal: 'contacts/tagDeleteForm/isPersonal',
      tag: 'contacts/tagDeleteForm/tag'
    })
  },
  methods: {
    ...mapActions({
      deleteTag: 'contacts/tags/delete',
      deletePersonalTag: 'contacts/personalTags/delete',
      close: 'contacts/tagDeleteForm/close'
    }),

    submit () {
      if (this.isPersonal) {
        this.deletePersonalTag(this.tag)
      } else {
        this.deleteTag(this.tag)
      }
      this.close()
    }
  }
}
</script>

<style>

</style>
